import { KeyTransactions } from 'components/tables/TransactionsTable/data';
import { getCodeCurrencyOfName, getYYYYMMDD } from 'helpers/formatters';
import { activationOrderDataType } from 'hooks/api/useActivationOrder';

export type DefaultInterestOutstandingT = NonNullable<activationOrderDataType['default_interest_outstanding']>[number];

export const formatDefaultInterestDate = (date?: null | string): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date || '');

  if (!match) return '';

  const [, year, month, day] = match;

  return `${day}.${month}.${year}`;
};

export const getDefaultInterestOutstandingRows = (
  activationOrderData?: Partial<activationOrderDataType> | null,
): DefaultInterestOutstandingT[] => {
  const rows = activationOrderData?.default_interest_outstanding || [];

  if (rows.length > 0) return rows;

  return [{ amount: null, currency: activationOrderData?.currency, as_of_date: null }];
};

export type TransactionPrefillT = {
  [KeyTransactions.TYPE]: KeyTransactions;
  [KeyTransactions.CATEGORY]: KeyTransactions;
  [KeyTransactions.VALUE_DATE_TIME]: string;
  [KeyTransactions.RECIPIENT]: {
    [KeyTransactions.COMPANY_ID]: string;
    [KeyTransactions.COMPANY_NAME]: string;
  };
  [KeyTransactions.CURRENCY]: number | string;
  [KeyTransactions.AMOUNT]: string;
  [KeyTransactions.DOCUMENT_AO]: string;
  [KeyTransactions.DOCUMENT_ID]: string;
  [KeyTransactions.DOCUMENT_NUMBER]: string;
  [KeyTransactions.DOCUMENT_TYPE]: string;
};

type AoWithDefaultInterestT = Pick<
  activationOrderDataType,
  'id' | 'name' | 'currency' | 'company_id' | 'company_name' | 'default_interest_outstanding'
>;

export const getOutstandingDefaultInterest = (
  activationOrderData?: Partial<AoWithDefaultInterestT> | null,
  currency?: string | null,
): DefaultInterestOutstandingT | null => {
  const outstanding = (activationOrderData?.default_interest_outstanding || []).filter(
    (item) => Number(item?.amount) > 0,
  );
  const wantedCurrency = currency || activationOrderData?.currency;

  if (!wantedCurrency) return outstanding[0] || null;

  return outstanding.find((item) => item.currency === wantedCurrency) || null;
};

export const buildDefaultInterestPrefill = (
  activationOrderData: Partial<AoWithDefaultInterestT>,
  defaultInterest: DefaultInterestOutstandingT,
): TransactionPrefillT => ({
  [KeyTransactions.TYPE]: KeyTransactions.INTERNAL,
  [KeyTransactions.CATEGORY]: KeyTransactions.INTERNAL_DEFAULT_INTEREST,
  [KeyTransactions.VALUE_DATE_TIME]: getYYYYMMDD(new Date()),
  [KeyTransactions.RECIPIENT]: {
    [KeyTransactions.COMPANY_ID]: activationOrderData.company_id ?? '',
    [KeyTransactions.COMPANY_NAME]: activationOrderData.company_name ?? '',
  },
  [KeyTransactions.CURRENCY]: getCodeCurrencyOfName(defaultInterest.currency ?? activationOrderData.currency ?? ''),
  [KeyTransactions.AMOUNT]: defaultInterest.amount ?? '',
  [KeyTransactions.DOCUMENT_AO]: activationOrderData.id ?? '',
  [KeyTransactions.DOCUMENT_ID]: activationOrderData.id ?? '',
  [KeyTransactions.DOCUMENT_NUMBER]: activationOrderData.name ?? '',
  [KeyTransactions.DOCUMENT_TYPE]: 'order',
});
